export const optionsOfStates = [
  { label: 'All', value: 'all' },
  { label: 'planned', value: 'planned' },
  { label: 'completed', value: 'completed' },
];

export default optionsOfStates;
